// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5196":"9c900597","7282":"14fc6499","8473":"9c900597"}[chunkId] + ".chunk.css";
};